<template>
    <PullContainer ref="pullContainerRef" :pullDownLoading="false" :pullDownLabel="false">
        <template #container>
            <div class="public_container customer_seas_wrap">
                <div class="returnNavBar">
                    <ReturnNavBar title="返回" :isTitleNormal="true" :isAllFunctions="true" :isCustomReturnEvent="true" @returnEvent="handleClickReturn"> </ReturnNavBar>
                    <div class="mobile_head_operate" v-if="userType == 'admin'">
                        <span @click="handleClickUserTypeChange"><i class="iconfont icon-qiehuan"></i>切换员工版</span>
                    </div>
                </div>
                <div class="mobile_container customer_seas_wrap_content">
                    <div class="top_card">
                        <div class="card_item">
                            <p>新增客户</p>
                            <template v-if="userType == 'user'">
                                <div class="card_item_count">
                                    <p>
                                        <span>{{ statisticsData.customer.today }}</span
                                        ><span>/今</span>
                                    </p>
                                    <p>
                                        <span>{{ statisticsData.customer.yesterday }}</span
                                        ><span>/昨</span>
                                    </p>
                                </div>
                                <van-button size="small" type="info" @click="handleClickAddCustomer">新增></van-button>
                            </template>
                            <template v-else>
                                <div class="card_item_count card_item_count_user">
                                    <p>
                                        <span>{{ statisticsData.customer.today }}</span
                                        ><span>/今</span>
                                    </p>
                                </div>
                                <p class="card_item_count2">
                                    较昨日<span class="count_up">{{ statisticsData.customer.change }}%</span
                                    ><i
                                        class="iconfont"
                                        :class="
                                            statisticsData.customer.change > 0 ? 'icon-arrow-up' : 'icon-arrow-down'
                                        "
                                    ></i>
                                </p>
                            </template>
                        </div>
                        <div class="card_item">
                            <p>跟进次数</p>
                            <template v-if="userType == 'user'">
                                <div class="card_item_count">
                                    <p>
                                        <span>{{ statisticsData.follow_up.today }}</span
                                        ><span>/今</span>
                                    </p>
                                    <p>
                                        <span>{{ statisticsData.follow_up.yesterday }}</span
                                        ><span>/昨</span>
                                    </p>
                                </div>
                                <van-button size="small" plain type="info" @click="handleClickAddFollowUp"
                                    >新增></van-button
                                >
                            </template>
                            <template v-else>
                                <div class="card_item_count card_item_count_user">
                                    <p>
                                        <span>{{ statisticsData.follow_up.today }}</span
                                        ><span>/今</span>
                                    </p>
                                </div>
                                <p class="card_item_count2">
                                    较昨日<span class="count_down">{{ statisticsData.follow_up.change }}%</span
                                    ><i
                                        class="iconfont"
                                        :class="
                                            statisticsData.follow_up.change > 0 ? 'icon-arrow-up' : 'icon-arrow-down'
                                        "
                                    ></i>
                                </p>
                            </template>
                        </div>
                    </div>
                    <template v-if="userType == 'user'">
                        <div class="list_card list_card1">
                            <p class="list_card_title" @click="handleClickToForgetReminder">
                                客户遗忘提醒 <van-icon name="arrow"></van-icon>
                            </p>
                            <ul>
                                <li v-for="(row, rowIndex) in overdueFollowupsData" :key="rowIndex">
                                    <span class="ellipsis">{{ row.company_name }}</span>
                                    <span class="follow_count">已{{ row.overdue_days }}日未跟进</span>
                                </li>
                            </ul>
                        </div>
                        <div class="list_card list_card2">
                            <p class="list_card_title">申领进度</p>
                            <ul>
                                <li v-for="(row, rowIndex) in customerClaimsStatisticsData" :key="rowIndex">
                                    <span class="ellipsis">{{ row.customer_name }}</span>
                                    <div class="user_avatar_box" v-if="row.people">
                                        <div class="user_avatar" v-if="row.people.length">
                                            <img :src="row.people[0].avatar || defaultImg" alt="" /><span
                                                class="ellipsis"
                                                >{{ row.people[0].name }}</span
                                            >
                                        </div>
                                    </div>
                                    <span class="list_item_status" :class="'status_' + row.approval_status">{{
                                        getApprovalStatusText(row.approval_status)
                                    }}</span>
                                </li>
                            </ul>
                        </div>
                        <div class="list_card list_card3">
                            <p class="list_card_title" @click="handleClickToMajorCustomer">
                                重点客户<van-icon name="arrow"></van-icon>
                            </p>
                            <ul>
                                <li v-for="(row, rowIndex) in topFollowupsData" :key="rowIndex">
                                    <span class="ellipsis">{{ row.name }}</span>
                                    <span class="icon_hot" v-if="rowIndex === 0">热</span>
                                </li>
                            </ul>
                        </div>
                    </template>
                    <template v-else>
                        <div class="list_card list_card_user1">
                            <p class="list_card_title" @click="handleClickToOrderCustomers">
                                今日成单客户<van-icon name="arrow"></van-icon>
                            </p>
                            <ul>
                                <li v-for="(row, rowIndex) in todayCustomerOrdersData" :key="rowIndex">
                                    <span class="ellipsis">{{ row.customer_name }}</span>
                                    <span>{{ row.order_count }}单</span>
                                    <span
                                        >¥{{
                                            Number(row.total_amount).toLocaleString(undefined, {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2,
                                            })
                                        }}</span
                                    >
                                </li>
                            </ul>
                        </div>
                        <div class="list_card list_card_user2">
                            <div class="list_card_title">
                                今日跟进排行
                                <div class="list_filter_wrap" @click="handleClickFilter">
                                    <span>{{ filterTypeText }}</span
                                    ><van-icon name="arrow-down" />
                                </div>
                            </div>
                            <ul>
                                <li v-for="(row, index) in todayCustomerTopSalesData" :key="index">
                                    <img
                                        class="item_rank"
                                        v-if="index == 0"
                                        src="https://download.hecoos.com/enlightv/2024-47/dfe5dcbf3b99214fed70d2542877b4ca.png"
                                        alt=""
                                    />
                                    <img
                                        class="item_rank"
                                        v-else-if="index == 1"
                                        src="https://download.hecoos.com/enlightv/2024-47/59ec13fce571083dad69afd19f433c81.png"
                                        alt=""
                                    />
                                    <img
                                        class="item_rank"
                                        v-else-if="index == 2"
                                        src="https://download.hecoos.com/enlightv/2024-47/7fd727b6dde228af3edd2eefa35a8f0a.png"
                                        alt=""
                                    />
                                    <i v-else class="item_rank">{{ index + 1 }}</i>
                                    <span class="ellipsis">{{ row.name }}</span>
                                    <span>{{ row.count }}次</span>
                                </li>
                            </ul>
                        </div>
                    </template>
                </div>
                <FooterTabbar :tabBarList="tabBarList" :tabBarActive="tabBarActive"></FooterTabbar>
                <van-overlay
                    :custom-style="{ background: 'rgba(0, 0, 0, 0.3)' }"
                    v-if="showRadioPicker"
                    :show="showRadioPicker"
                >
                    <div class="radio_option_wrap">
                        <ul class="radio_option_list">
                            <li
                                v-for="item in filterTypeList"
                                class="radio_option_item"
                                @click="handleClickRadioOption(item)"
                                v-text="item.label"
                            ></li>
                        </ul>
                        <div class="cancel_btn" @click="showRadioPicker = false">取消</div>
                    </div>
                </van-overlay>
            </div>
            <!-- 客户选择 -->
            <CompanySearchSelect
                :customerSelectVisible.sync="customerSelectVisible"
                :customerSelectTitle="customerSelectTitle"
                @selectCustomerData="handleSelectCustomerData"
                v-if="customerSelectVisible"
            />
            <AddCustomerFollowTpl
                v-if="addFollowTplPopupShow"
                :addFollowTplPopupShow.sync="addFollowTplPopupShow"
                :customer_id="Number(customer_id)"
                @addFollowTplSuccess="initData"
            />
        </template>
    </PullContainer>
</template>
<script>
import {
    CustomerIndexStatistics,
    OverdueFollowups,
    CustomerClaimsStatistics,
    TopFollowups,
    TodayCustomerOrders,
    TodayCustomerTopSales,
    CustomerH5IsAdmin,
} from "@/api";
import PullContainer from "@/components/mComponents/PullContainer.vue";
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";
import FooterTabbar from "@/components/mComponents/FooterTabbar.vue";
import CompanySearchSelect from "./component/company_search_select.vue";
import AddCustomerFollowTpl from "./customer_follow_tpl.vue";
export default {
    name: "CustomerHighSeas",
    components: { PullContainer, ReturnNavBar, FooterTabbar, CompanySearchSelect, AddCustomerFollowTpl },
    data() {
        return {
            defaultImg: require("@/assets/images/default.jpg"),
            tabBarList: [
                {
                    icon: "icon-shouye",
                    activeIcon: "icon-shouyexuanzhong",
                    routerName: "MCustomerSeas",
                    title: "首页",
                },
                {
                    icon: "icon-a-fenzu450",
                    activeIcon: "icon-gonghai-xuanzhong",
                    routerName: "CustomerHighSeas",
                    title: "公海客户",
                },
                {
                    icon: "icon-sihai",
                    activeIcon: "icon-sihai-xuanzhong",
                    routerName: "CustomerPrivateSeas",
                    title: "私海客户",
                },
            ],
            tabBarActive: 0,
            isAdmin: false,
            isAdminInfo: {},
            userType: "user", // 用户类型
            showRadioPicker: false,
            filterTypeText: "今日",
            filterType: "today",
            filterTypeList: [
                { value: "today", label: "今日" },
                { value: "week", label: "本周" },
                { value: "month", label: "本月" },
            ],
            statisticsData: {
                customer: {
                    change: 0,
                    today: 0,
                    yesterday: 0,
                },
                follow_up: {
                    change: 0,
                    today: 0,
                    yesterday: 0,
                },
            },
            overdueFollowupsData: [],
            customerClaimsStatisticsData: [],
            topFollowupsData: [],
            todayCustomerOrdersData: [],
            todayCustomerTopSalesData: [],

            customerSelectVisible: false,
            customerSelectTitle: "选择公司",
            // 写跟进
            customer_id: 0,
            addFollowTplPopupShow: false,
        };
    },
    created() {
        this.getCustomerH5IsAdmin();
    },
    methods: {
        handleClickReturn() {
            if(this.isAdmin && this.userType === 'user') {
                this.userType = 'admin'
                this.getCustomerIndexStatistics()
            } else {
                if (this.$router.history.length <= 1) {
                    // 没有上一页，跳转到固定页面
                    this.$router.push({ name: 'mobileAllFunctions' });
                } else {
                    // 有上一页，后退
                    this.$router.go(-1);
                }
            }
        },
        // 获取是否是管理员
        getCustomerH5IsAdmin() {
            CustomerH5IsAdmin().then((res) => {
                if (res.code === 200) {
                    this.isAdminInfo = res.data;
                    this.isAdmin = res.data.isAdmin;
                    this.userType = this.isAdmin ? "admin" : "user";
                }
                this.$nextTick(() => {
                    this.initData();
                });
            });
        },
        // 初始化数据
        initData() {
            this.getCustomerIndexStatistics();
            if (this.isAdmin) {
                this.getTodayCustomerOrders();
                this.getTodayCustomerTopSales();
            }
            this.getOverdueFollowups();
            this.getCustomerClaimsStatistics();
            this.getTopFollowups();
        },
        // 员工版和管理员版展示切换
        handleClickUserTypeChange() {
            this.userType = "user";
            this.getCustomerIndexStatistics()
        },
        // 今日跟进排行筛选
        handleClickFilter() {
            this.showRadioPicker = true;
        },
        handleClickRadioOption(item) {
            this.filterType = item.value;
            this.filterTypeText = item.label;
            this.showRadioPicker = false;
            this.$nextTick(() => {
                this.getTodayCustomerTopSales();
            });
        },
        // 获取审批状态
        getApprovalStatusText(approval_status) {
            let text = "";
            switch (approval_status) {
                case 0:
                    text = "审批中";
                    break;
                case 1:
                    text = "已通过";
                    break;
                case 2:
                    text = "已拒绝";
                    break;
                case 3:
                    text = "已撤销";
                    break;
            }
            return text;
        },
        // 获取新增客户-跟进
        getCustomerIndexStatistics() {
            // let params = (this.isAdmin && this.userType === 'admin') ? this.isAdminInfo : {}
            CustomerIndexStatistics().then((res) => {
                if (res.code === 200) {
                    this.statisticsData = res.data;
                }
            });
        },
        // 获取客户遗忘提醒数据
        getOverdueFollowups() {
            OverdueFollowups({ page: 1, pageSize: 3 }).then((res) => {
                if (res.code === 200) {
                    const { list, total } = res.data;
                    this.overdueFollowupsData = list || [];
                }
            });
        },
        // 获取申领进度
        getCustomerClaimsStatistics() {
            CustomerClaimsStatistics({ page: 1, pageSize: 3 }).then((res) => {
                if (res.code === 200) {
                    const { list, total } = res.data;
                    this.customerClaimsStatisticsData = list || [];
                }
            });
        },
        // 获取重点客户
        getTopFollowups() {
            TopFollowups({ page: 1, pageSize: 3 }).then((res) => {
                if (res.code === 200) {
                    const { list, total } = res.data;
                    this.topFollowupsData = list || [];
                }
            });
        },
        // 查看今日成单客户
        getTodayCustomerOrders() {
            let params = {
                page: 1, 
                pageSize: 3
            }
            // if(this.isAdmin && this.userType === 'admin') {
            //     params = {...params, ...this.isAdminInfo}
            // }
            TodayCustomerOrders(params).then((res) => {
                if (res.code === 200) {
                    const { list, total } = res.data;
                    this.todayCustomerOrdersData = list || [];
                }
            });
        },
        // 查看今日跟进排行
        getTodayCustomerTopSales() {
            let params = {
                range: this.filterType 
            }
            // if(this.isAdmin && this.userType === 'admin') {
            //     params = {...params, ...this.isAdminInfo}
            // }
            TodayCustomerTopSales(params).then((res) => {
                if (res.code === 200) {
                    this.todayCustomerTopSalesData = res.data || [];
                }
            });
        },
        // 查看客户遗忘提醒
        handleClickToForgetReminder() {
            this.$router.push({
                name: "CustomerForgetReminder",
            });
        },
        // 查看重点客户
        handleClickToMajorCustomer() {
            this.$router.push({
                name: "MajorCustomer",
            });
        },
        // 查看今日成单客户
        handleClickToOrderCustomers() {
            this.$router.push({
                name: "OrderCustomers",
            });
        },
        // 新增客户
        handleClickAddCustomer() {
            this.$router.push({
                name: "MCustomerAdd",
                query: {
                    addType: "private",
                },
            });
        },
        // 新增跟进
        handleClickAddFollowUp() {
            this.customerSelectVisible = true;
        },
        // 选择客户数据
        handleSelectCustomerData(data) {
            if (data && data.id) {
                this.customer_id = data.id;
                this.addFollowTplPopupShow = true;
            }
        },
    },
};
</script>
<style lang="scss" scoped>
.customer_seas_wrap {
    .top {
        height: 44px;
    }
    .mobile_head_operate {
        .iconfont {
            margin-right: 8px;
        }
        span {
            font-size: 12px;
            width: auto;
            color: #333333;
            .iconfont {
                font-size: 12px;
            }
        }
    }

    .icon_hot {
        padding: 0 2px;
        height: 12px;
        line-height: 12px;
        font-size: 8px;
        background-color: rgba(228, 65, 68, 1);
        color: #ffffff;
        border-radius: 4px;
    }

    .customer_seas_wrap_content {
        padding: 10px 16px;

        .top_card {
            width: 100%;
            display: flex;
            gap: 11px;

            .card_item {
                flex: 1;
                height: 96px;
                border-radius: 8px;
                background-color: rgba(219, 237, 255, 0.5);
                backdrop-filter: blur(20px);
                padding: 10px;
                position: relative;

                & > p {
                    font-size: 16px;
                    font-weight: 700;
                    letter-spacing: 0px;
                    line-height: 23px;
                    color: rgba(34, 34, 34, 1);
                }

                .card_item_count {
                    margin-top: 2px;
                    display: flex;
                    gap: 10px;

                    p {
                        span {
                            font-weight: 700;
                            letter-spacing: 0px;
                            line-height: 22px;
                            color: rgba(51, 51, 51, 1);
                        }

                        span:nth-child(1) {
                            font-size: 14px;
                        }
                        span:nth-child(2) {
                            font-size: 10px;
                        }
                    }
                }

                .card_item_count_user {
                    p {
                        span {
                            line-height: 34px;
                            color: rgba(34, 34, 34, 1);
                        }

                        span:nth-child(1) {
                            font-size: 24px;
                        }
                    }
                }

                .card_item_count2 {
                    font-size: 10px;
                    font-weight: 400;
                    letter-spacing: 0px;
                    height: 14px;
                    line-height: 14px;
                    color: rgba(153, 153, 153, 1);
                    display: flex;
                    align-items: flex-end;

                    .count_down,
                    .icon-arrow-down {
                        font-weight: 700;
                        color: rgba(90, 179, 51, 1);
                    }

                    .count_up,
                    .icon-arrow-up {
                        font-weight: 700;
                        color: rgba(228, 65, 68, 1);
                    }

                    .icon-arrow-down,
                    .icon-arrow-up {
                        font-size: 13px;
                    }
                }

                .van-button {
                    margin-top: 6px;
                    border-radius: 10px;
                    height: 16px;
                    padding: 1px 6px;
                    font-size: 10px;
                    font-weight: 700;
                    line-height: 16px;
                }

                .van-button--info {
                    background-color: rgba(122, 184, 255, 1);
                    border-color: rgba(122, 184, 255, 1);
                    color: rgba(255, 255, 255, 1);
                }

                .van-button--plain {
                    background-color: rgba(255, 255, 255, 1);
                    border-color: rgba(122, 184, 255, 1);
                    color: rgba(122, 184, 255, 1);
                }
            }

            & > div:nth-child(1) {
                background-image: url("https://download.hecoos.com/enlightv/2024-50/b03a91c49feb0a7ce3f07a718e6c0dda.png");
                background-position: calc(100% - 4px) bottom;
                background-size: 65px 70px;
                background-repeat: no-repeat;
            }

            & > div:nth-child(2) {
                background-image: url("https://download.hecoos.com/enlightv/2024-50/c67b80e135148144b4978f1c2508bc24.png");
                background-position: calc(100% - 4px) bottom;
                background-size: 65px 70px;
                background-repeat: no-repeat;
            }
        }

        .list_card {
            padding: 12px 10px 6px;
            border-radius: 6px;
            background: rgba(255, 255, 255, 1);
            margin-top: 10px;

            .list_card_title {
                font-size: 14px;
                font-weight: 700;
                letter-spacing: 0px;
                line-height: 22px;
                color: rgba(34, 34, 34, 1);
                display: flex;
                justify-content: space-between;
                margin-bottom: 6px;

                .van-icon {
                    font-size: 14px;
                    color: rgba(102, 102, 102, 1);
                    font-weight: 700;
                }

                .list_filter_wrap {
                    width: 60px;
                    height: 24px;
                    opacity: 1;
                    border-radius: 4px;
                    border: 1px solid rgba(0, 0, 0, 0.2);
                    display: flex;
                    gap: 8px;
                    align-items: center;
                    justify-content: center;

                    span {
                        font-size: 12px;
                        font-weight: 400;
                        letter-spacing: 0px;
                        line-height: 17.38px;
                        color: rgba(51, 51, 51, 1);
                    }
                }
            }

            ul {
                li {
                    padding: 6px 0;
                    font-size: 12px;
                    font-weight: 400;
                    letter-spacing: 0px;
                    line-height: 18px;
                    color: rgba(51, 51, 51, 1);
                    display: flex;
                    gap: 10px;
                    justify-content: space-between;
                    align-items: center;

                    .ellipsis {
                        flex: 1;
                    }

                    span:not(:first-child) {
                        flex-shrink: 0;
                    }

                    .follow_count {
                        font-size: 10px;
                        font-weight: 400;
                        letter-spacing: 0px;
                        line-height: 14.48px;
                        color: rgba(153, 153, 153, 1);
                    }

                    .user_avatar_box {
                        width: 78px;

                        .user_avatar {
                            height: 18px;
                            display: flex;
                            align-items: center;

                            img {
                                width: 18px;
                                height: 18px;
                                border-radius: 50%;
                                margin-right: 2px;
                            }

                            span {
                                max-width: 58px;
                                font-size: 12px;
                                font-weight: 400;
                                letter-spacing: 0px;
                                line-height: 18px;
                                color: rgba(51, 51, 51, 1);
                            }
                        }
                    }

                    .list_item_status {
                        width: 46px;
                        height: 22px;
                        text-align: center;
                        line-height: 22px;
                        border-radius: 50px;
                        font-size: 11px;
                        font-weight: 400;
                        letter-spacing: 0px;

                        &.status_0 {
                            background-color: rgba(41, 144, 255, 0.1);
                            color: rgba(41, 144, 255, 1);
                        }

                        &.status_1 {
                            background: rgba(75, 159, 71, 0.1);
                            color: rgba(75, 159, 71, 1);
                        }

                        &.status_2 {
                            background-color: rgba(228, 65, 68, 0.1);
                            color: rgba(228, 65, 68, 1);
                        }
                        &.status_3 {
                            background: rgba(191, 191, 191, 0.1);
                            color: #bfbfbf;
                        }
                    }
                }
            }

            &.list_card1,
            &.list_card3,
            &.list_card_user1 {
                height: 136px;
            }

            &.list_card2 {
                height: 140px;
            }

            &.list_card_user2 {
                height: 189px;
            }
            &.list_card1 {
                position: relative;
                background-image: url("https://download.hecoos.com/enlightv/2024-50/fc10d0dcbd8335bc60e52c62d6044beb.png");
                background-position: calc(100% - 20px) 20px;
                background-size: 90px 86px;
                background-repeat: no-repeat;
            }
            &.list_card2 {
                position: relative;
                background-image: url("https://download.hecoos.com/enlightv/2024-50/8a3cec3da3e820e83d70af1a9876d3d8.png");
                background-position: calc(100% - 20px) 20px;
                background-size: 90px 85px;
                background-repeat: no-repeat;
            }
            &.list_card3 {
                position: relative;
                background-image: url("https://download.hecoos.com/enlightv/2024-50/87b56b812689e9513ef9d59a53dd7a0c.png");
                background-position: calc(100% - 24px) 24px;
                background-size: 82px 77px;
                background-repeat: no-repeat;
            }
        }

        .list_card_user1 {
            position: relative;
            background-image: url("https://download.hecoos.com/enlightv/2024-50/0be71b71199f6b69081eedf356c4f0b9.png");
            background-position: calc(100% - 20px) 20px;
            background-size: 90px 85px;
            background-repeat: no-repeat;

            ul {
                li {
                    span {
                        font-size: 12px;
                        font-weight: 400;
                        letter-spacing: 0px;
                        line-height: 18px;
                        color: rgba(51, 51, 51, 1);
                    }

                    span:nth-child(2) {
                        width: 62px;
                        text-align: center;
                    }

                    span:nth-child(3) {
                        width: 94px;
                        text-align: right;
                    }
                }
            }
        }

        .list_card_user2 {
            position: relative;
            background-image: url("https://download.hecoos.com/enlightv/2024-50/4d763a59f4757882a5254c4675fa5f59.png");
            background-position: calc(100% - 20px) 20px;
            background-size: 90px 85px;
            background-repeat: no-repeat;

            ul {
                li {
                    .item_rank {
                        width: 20px;
                        height: 18px;
                        text-align: center;
                    }
                }
            }
        }
    }
    .radio_option_wrap {
        width: 100%;
        height: 100%;
        padding: 0 16px 35px;
        display: flex;
        flex-direction: column;
        justify-content: end;

        .radio_option_list {
            border-radius: 8px;
            max-height: calc(100% - 90px);
            overflow-y: auto;

            .radio_option_item {
                background-color: #ffffff;
                text-align: center;
                font-size: 16px;
                font-weight: 400;
                line-height: 24px;
                padding: 10px 0;
                color: #666666;
                border-bottom: 1px solid #dedede;

                &:first-child {
                    border-radius: 8px 8px 0 0;
                }

                &:last-child {
                    border-bottom: none;
                    border-radius: 0 0 8px 8px;
                }
            }
        }

        .cancel_btn {
            background-color: #ffffff;
            text-align: center;
            font-size: 16px;
            font-weight: 400;
            line-height: 24px;
            padding: 10px 0;
            color: #666666;
            border-radius: 8px;
            box-shadow: 0px -2px 4px rgba(0, 0, 0, 0.08);
            margin-top: 10px;
        }
    }
}
</style>
